import { render, staticRenderFns } from "./FormNameOnboarding.vue?vue&type=template&id=7f40b768&scoped=true&"
import script from "./FormNameOnboarding.vue?vue&type=script&lang=js&"
export * from "./FormNameOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./FormNameOnboarding.vue?vue&type=style&index=0&id=7f40b768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40b768",
  null
  
)

export default component.exports